import Image from "next/image";
import styles from "./banner.module.css";

export default function Banner({ data }) {
  return (
    <div className={`${styles.bg}`}>
      {data.imagem.url && (
        <Image
          src={data.imagem.url}
          alt="Detalhe imóvel"
          layout="fill"
          objectFit="cover"
          objectPosition="center"
        />
      )}
      <div className="grid-cont">
        <div className={styles.content}>
          <div className={styles.phaseCity}>
            <div
              className={styles.parallelogramSpan}
              style={{ background: data.etapaImovel.cor }}
            >
              <span>{data.etapaImovel.etapa}</span>
            </div>
            <span>{data.cidade.cidade}</span>
            <span>-</span>
            <span>{data.cidade.uf}</span>
          </div>
          <h1 className={styles.name}>{data.nome}</h1>
          <div className={styles.typologyDesc}>
            <span>{data.tipologia}</span>
            <span>{data.chamada}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
